module.exports = {"svg":{"$":{"width":"255px","height":"308px","viewBox":"0 0 255 308","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"},"path":[{"$":{"id":"Shape","d":"M127.4 307.4 0 153.7 78.3 153.7 78.3 0 176.4 0 176.4 153.7 254.8 153.7z"}}]}}


//////////////////
// WEBPACK FOOTER
// ./~/xml-loader!./src/svg/icon-arrow--down.svg
// module id = 491
// module chunks = 0